<template>
    <div>
        <PieChart ref="distributionPieChart" :chart-data="chartData" :options="pieChartOptions" :width="Width" :height="Height" />
    </div>
</template>

<script>

    import { colorHelper } from '@/shared/color-helper';
    import PieChart from '@/components/charts/core/pie-chart';
 
    export default {
        name: 'GainLossPieChart',

        props: {
            TaxRecords: {
                type: Array,
                default: () => [],
            },
            Width: {
                type: Number,
                default: () => 330,
            },
            Height: {
                type: Number,
                default: () => 330,
            },
        },

        /* COMPONENT DATA  */
        data() {
            return {
                pieChartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    onClick: this.handleDistributionPieChartClick,
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem, data) {
                                let label = data.labels[tooltipItem.index];
                                let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                return ' ' + label + ': $' + value;
                            }
                        }
                    }
                },
            };
        },

        /* CHILD COMPONENTS  */
        components: {
            PieChart
        },

        /* COMPONENT METHODS  */
        methods: {
            handleDistributionPieChartClick(evt, elements) {
                var chart = this.$refs.distributionPieChart.$data._chart;
                const chartIndex = chart.getElementAtEvent(evt);
                if (chartIndex.length !== 0) {
                    const datasetIndex = chartIndex[0]._datasetIndex;
                    const position = chartIndex[0]._index;
                    const info = {
                        datasetIndex: datasetIndex,
                        valueIndex: position,
                        label: chart.tooltip._data.labels[position],
                        value: chart.tooltip._data.datasets[datasetIndex].data[position]
                    };
                }
            },

            resetChart() {
                //Reset the chart if available
                if (this.$refs.distributionPieChart) {
                    var chart = this.$refs.distributionPieChart.$data._chart;

                    //Uncheck legend items on pie chart
                    var meta = chart.getDatasetMeta(0);
                    meta.data.forEach(function (ds) {
                        ds.hidden = false;
                    });

                    chart.update(); //Update chart with new data and cleared legend
                }
            },
        },

        /* COMPUTED PROPERTIES */
        computed: {
          
            allAssets() {
                //Retrieve a list of distinct assets with transactions
                if (this.TaxRecords.length > 0) {
                    var assets = [...new Set(this.TaxRecords.map(a => a.assetName).sort())];
                    return assets;
                }
                else
                    return [];
            },

            chartData() {

                var chartData = [];
                let dataArray = [];
                let labelArray = [];
                let colorArray = [];
                for (var x = 0; x < this.allAssets.length; x++) {
                    var asset = this.allAssets[x];
                    var total = this.TaxRecords.filter(x => x.assetName == asset).reduce((n, { gain }) => n + parseFloat(gain), 0);
                    labelArray.push([asset]);
                    dataArray.push(total.toFixed(2));
                }

                colorArray = colorHelper.getColorPalette("happy", this.allAssets.length);
                //colorArray = colorHelper.getRandomColorPalette(this.allAssets.length);

                chartData = {
                    labels: labelArray,
                    datasets: [
                        {
                            backgroundColor: colorArray,
                            data: dataArray
                        }
                    ]
                };

                return chartData;
            }
        }
    };
</script>